import { connectStudyCloud } from "./studyCloud";
import {
  applyCloudSnapshot,
  attachCloud,
  clearLocalStudy,
  detachCloud,
  getLocalStudy,
  mergeStudy,
} from "../utils/myStudy";

/*
 * Follows sign-in and sign-out and points My Study at the right copy:
 *
 * - signed in: the account's copy. Whatever this browser saved before is
 *   merged into the account first (mergeStudy), and the browser's own copy is
 *   cleared only after the account has accepted it, so a failed write loses
 *   nothing -- the import simply runs again next sign-in;
 * - signed out: back to this browser's copy.
 *
 * Driven by src/firebase/account.js, which calls followStudy on every sign-in
 * and sign-out.
 */

let stopSubscription = null;
let currentUid = null;

function stopCurrent() {
  if (stopSubscription) stopSubscription();
  stopSubscription = null;
  currentUid = null;
}

export async function followStudy(services, user) {
  stopCurrent();

  if (!user) {
    detachCloud();
    return;
  }

  const uid = user.uid;
  currentUid = uid;

  const cloud = connectStudyCloud({
    db: services.db,
    firestoreApi: services.firestoreApi,
    uid,
  });

  /* Until the account answers, keep showing what this browser has, so the
     save buttons do not flicker to "unsaved". Writes already go to the account. */
  const local = getLocalStudy();
  attachCloud(cloud.adapter, local);

  try {
    const account = await cloud.fetchAll();
    if (currentUid !== uid) return;

    const { items, pathProgress } = mergeStudy(local, account);
    if (items.length || pathProgress) {
      await cloud.writeMany(items, pathProgress);
    }
    if (currentUid !== uid) return;

    clearLocalStudy();
  } catch (error) {
    console.warn("My Study: could not bring this browser's study into your account", error);
  }

  if (currentUid !== uid) return;

  stopSubscription = cloud.subscribe(applyCloudSnapshot, (error) => {
    console.warn("My Study: lost the connection to your account", error);
  });
}
